// theme
export const TOGGLE_THEME = 'TOGGLE_THEME'

// movies
export const GET_POPULAR_MOVIES = 'GET_POPULAR_MOVIES'
export const GET_TOP_RATED_MOVIES = 'GET_TOP_RATED_MOVIES'
export const GET_NOW_PLAYING_MOVIES = 'GET_NOW_PLAYING_MOVIES'
export const SEARCH_MOVIES = 'SEARCH_MOVIES'
export const SET_LOADING = 'SET_LOADING'

// tv shows
export const GET_POPULAR_TVSHOWS = 'GET_POPULAR_TVSHOWS'
export const GET_TOP_RATED_TVSHOWS = 'GET_TOP_RATED_TVSHOWS'
export const GET_NOW_PLAYING_TVSHOWS = 'GET_NOW_PLAYING_TVSHOWS'
